import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import autoBind from 'react-autobind'
import _ from 'lodash'
import Dropzone from 'react-dropzone'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import { cyan900 } from 'material-ui/styles/colors'
import { authInfo, pageNavigation, editItem, syncWithNetsuite } from '../../actions'
import { uploadImage } from '../../lib/upload'
import DialogModal from '../home/DialogModal'
import EditorData from './Common/EditorData'
import PrintData from './Common/PrintData'
import ItemInfo from './Common/ItemInfo'
import PreviewData from './Common/PreviewData'
import ShippingData from './Common/ShippingData';

const propTypes = {
  item: PropTypes.any,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  onView: PropTypes.func,
  products: PropTypes.any,
};
const dropzoneStyles = {
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)'
}

const clientOptions = {
  sessionCache: true
}
const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)
class EditItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
        sku: null,
      },
      item: {
        id: 0,
        productId: null,
        sku: '',
        name: '',
        foldername: '',
        msrp: 0,
        disabled: false,
        outOfStock: false,
        maskHorizontal: '',
        maskVertical: '',
        printWidth: 0,
        printHeight: 0,
        socialImage: '',
        previewShape: '',
        shippingData: {
          height: 0,
          width: 0,
          length: 0,
          weight: 0,
        },
        printData: {
          printMinPpi: 0,
          portrait: [{
            width: 0,
            height: 0,
            rotate: 0,
            sku: '',
            index: 1,
            pdfIndex: 1,
            x: 0,
            y: 0,
            bleed: false,
            textX: 0,
            textY: 0,
            textWidth: 0,
            textHeight: 0,
            fontColor: ""
          }],
          landscape: [{
            width: 0,
            height: 0,
            rotate: 0,
            sku: '',
            index: 1,
            pdfIndex: 1,
            x: 0,
            y: 0,
            bleed: false,
            textX: 0,
            textY: 0,
            textWidth: 0,
            textHeight: 0,
            fontColor: ""
          }],
        },
        preview: {
          portrait: [{
            img: '',
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            angle: 0,
            index: 1,
            z: 0,
            zoomedOverlay: '',
            zoomedX: 0,
            zoomedY: 0,
            zoomedWidth: 0,
            zoomedHeight: 0,
            textX: 0,
            textY: 0,
            textWidth: 0,
            textHeight: 0,
            fontColor: ""
          }],
          landscape: [{
            img: '',
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            angle: 0,
            index: 1,
            z: 0,
            zoomedOverlay: '',
            zoomedX: 0,
            zoomedY: 0,
            zoomedWidth: 0,
            zoomedHeight: 0,
            textX: 0,
            textY: 0,
            textWidth: 0,
            textHeight: 0,
            fontColor: ""
          }],
          numPhotos: 1,
        },
        editor: {
          border: 0,
          orientation: 'portrait',
          width: 0,
          height: 0,
          bandHeight: 0,
          textSize: 0,
        },
      },
      open: false,
      edited: false,
      viewRedirect: false,
      useNewPreview: false,
      sageManufactured: true,
      selectedPreview:{},
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let item;
    if (nextProps.item.id) {
      item = nextProps.item;
    } else {
      item = nextProps.item[0];
    }
    // item.productId = (item.productId === null) ? 0 : item.productId;
    this.setState({ item });
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const item = this.state.item;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = item[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleProductChange(event, index, value) {
    const nextState = this.state.item;
    nextState.productId = value;
    this.setState({
      item: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleOrientationChange(event, index, value) {
    const nextState = this.state.item;
    nextState.editor.orientation = value;
    this.setState({
      item: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChange(e) {
    const nextState = this.state.item;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      item: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleUploadedImage(name, value) {
    const nextState = this.state.item;
    _.set(nextState, name, value)
    this.setState({
      item: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChangePrintdata(e) {
    const nextState = this.state.item.printData;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      printData: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChangePreview(e) {
    const nextState = this.state.item.preview;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, e.target.value);
    }
    this.setState({
      preview: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  ChangePreviewImages(name, value) {
    const nextState = this.state.item.preview;
    _.set(nextState, name, value)
    this.setState({
      preview: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleChangeShipping(e) {
    const nextState = this.state.item.shippingData;
    if (e.target.type === 'checkbox') {
      _.set(nextState, e.target.name, e.target.checked);
    } else {
      _.set(nextState, e.target.name, Number(e.target.value));
    }
    this.setState({
      shippingData: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleNumPhotos(e) {
    const { item } = this.state
    item.preview.numPhotos = e.target.value
    this.setState({
      item,
      edited: true
    })
    this.setRequiredParams()
    this.addFieldsBasedOnNumPhotos(e.target.value)
  }
  addFieldsBasedOnNumPhotos(value) {
    var printDataArray = this.state.item.printData
    var previewArray = this.state.item.preview
    if (printDataArray.portrait.length < value) {
      for (var i = printDataArray.portrait.length; i < value; i++) {
        printDataArray.portrait.push({
          bleed: false,
          height: 0,
          index: i + 1,
          pdfIndex: i + 1,
          rotate: 0,
          sku: '',
          width: 0,
        })
      }
      for (var i = previewArray.portrait.length; i < value; i++) {
        previewArray.portrait.push({
          angle: 0,
          height: 0,
          img: '',
          index: i + 1,
          width: 0,
          x: 0,
          y: 0,
          z: 0,
          zoomedHeight: 0,
          zoomedOverlay: '',
          zoomedWidth: 0,
          zoomedX: 0,
          zoomedY: 0,
        })
      }
    }
  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Item';
    nextState.dialogMessage = 'Do you really want to delete this item?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      nextState.item.assignedOnly = false;
      this.setState(nextState);
      this.handleOpen();
    } else {
      this.props.dispatch(pageNavigation('view'))
    }
  }
  navigateToEdit() {
    this.props.dispatch(pageNavigation('edit'))
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      this.props.dispatch(pageNavigation('view'))
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Item Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this item?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.item.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(this.state.item);
        break;
      default:
        this.saveEditItem(this.state.item);
        break;
    }
  }
  saveEditItem(item) {
    this.setState({
      edited: true,
    });
    const pItem = item;
    pItem.preview  = this.state.useNewPreview ? this.state.selectedPreview : item.preview
    if(pItem.preview.portrait.length > 1){
      pItem.preview.landscape = pItem.preview.portrait.map((portrait) => {
        return {
          img: portrait.img,
          x:  portrait.x,
          y:  portrait.y,
          width:  portrait.width,
          height: portrait.height,
          angle: portrait.angle,
          index: portrait.index,
          z:  portrait.z,
          zoomedOverlay:  portrait.zoomedOverlay,
          zoomedX: portrait.zoomedX,
          zoomedY: portrait.zoomedY,
          zoomedWidth: portrait.zoomedWidth,
          zoomedHeight: portrait.zoomedHeight,
          textX: portrait.textX,
          textY: portrait.textY,
          textWidth: portrait.textWidth,
          textHeight: portrait.textHeight,
          fontColor: portrait.fontColor
        }
      }) 
    } else {
      pItem.preview.landscape.map((landscape) => {
        return {
          img: landscape.img,
          x:  landscape.x,
          y:  landscape.y,
          width:  landscape.width,
          height: landscape.height,
          angle: landscape.angle,
          index: landscape.index,
          z:  landscape.z,
          zoomedOverlay:  landscape.zoomedOverlay,
          zoomedX: landscape.zoomedX,
          zoomedY: landscape.zoomedY,
          zoomedWidth: landscape.zoomedWidth,
          zoomedHeight: landscape.zoomedHeight,
          textX: landscape.textX,
          textY: landscape.textY,
          textWidth: landscape.textWidth,
          textHeight: landscape.textHeight,
          fontColor: landscape.fontColor
        }
      })
      pItem.preview.portrait.map((portrait) => {
        return {
          img: portrait.img,
          x:  portrait.x,
          y:  portrait.y,
          width:  portrait.width,
          height: portrait.height,
          angle: portrait.angle,
          index: portrait.index,
          z:  portrait.z,
          zoomedOverlay:  portrait.zoomedOverlay,
          zoomedX: portrait.zoomedX,
          zoomedY: portrait.zoomedY,
          zoomedWidth: portrait.zoomedWidth,
          zoomedHeight: portrait.zoomedHeight,
          textX: portrait.textX,
          textY: portrait.textY,
          textWidth: portrait.textWidth,
          textHeight: portrait.textHeight,
          fontColor: portrait.fontColor
        }
      }) 
    }
    if(pItem.printData.portrait.length > 1){
      pItem.printData.landscape = pItem.printData.portrait.map((portrait) => {
        _.set(portrait, 'sku', `${portrait.sku}` )
        return {
          width: portrait.width,
          height: portrait.height,
          rotate: portrait.rotate,
          sku: `${portrait.sku}`,
          index: portrait.index,
          pdfIndex: portrait.pdfIndex,
          x: portrait.x,
          y:portrait.y,
          bleed: portrait.bleed,
          textX: portrait.textX,
          textY: portrait.textY,
          textWidth: portrait.textWidth,
          textHeight: portrait.textHeight,
          fontColor: portrait.fontColor
        }
      }) 
    }
    delete pItem.assignedOnly;
    pItem.img = (pItem.img === null) ? '' : pItem.img;
    this.props.dispatch(editItem(pItem));
  }
  handleCancel() {
    browserHistory.push('/items?page=1');
  }
  onDrop(file, bucket, name, handleChangeOption) {
    console.log('FILE', file)
    const { dispatch } = this.props
    console.log('# New file for bucket: ', bucket);
    console.log('# dispatching uploadImage...');
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, 0)
      .then((response) => {
        console.log('response***', response)
        handleChangeOption({
          target: {
            name: name,
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: name,
            value: file[0].name
          }
        })
        //alert(`Image upload failed: ${err}`);
        return '';
      });
  }
  onDropImage(file, bucket, name) {
    console.log('FILE', file)
    const { dispatch } = this.props
    console.log('# New file for bucket: ', bucket);
    console.log('# dispatching uploadImage...');
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, 0)
      .then((response) => {
        console.log('response***', response)
        this.handleChange({
          target: {
            name: name,
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: name,
            value: file[0].name
          }
        })
        //alert(`Image upload failed: ${err}`);
        return '';
      });
  }
  handleItemOptionSelect(event, index, value){
    console.log('Value in Select', value)
    this.setState({
      useNewPreview: true,
      selectedPreview: value.preview,
    })
  }
  handleDeleteImage(name, value){
    const nextState = this.state.item
    _.set(nextState, name, value)
    this.setState({
      item: nextState,
      edited: true,
    });
    this.setRequiredParams();
  }
  syncNetsuite(){
    const { item } = this.state
    this.props.dispatch(syncWithNetsuite(item.id))
  }
  render() {
    const itemPreview = this.state.useNewPreview ? this.state.selectedPreview : this.props.item.preview
    const { item } = this.state
    const { printData, maskHorizontal } = item
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      inputStyleLarge: {
        marginRight: '2%',
        width: '60%',
      },
      selectStyle: {
        lineHeight: '33px',
      },
    }
    return (
      <div style={{ width: '100%' }}>
        {!this.props.navigationType ? <h2>Edit Item</h2> : <h2>View Item</h2>}
        <div className="content">
          <DialogModal
            dialogOpen={this.state.open}
            dialogHandleClose={this.handleClose}
            dialogHandleSubmit={() => this.saveChanges()}
            dialogTitle={this.state.dialogTitle}
            dialogMessage={this.state.dialogMessage}
            dialogActionTitle={this.state.dialogActionTitle}
          />
          {!this.props.navigationType
            ? <div className="float-right">
              <RaisedButton
                label="Cancel"
                style={{ marginRight: '10px' }}
                primary
                onClick={this.handleCancel}
              />
              <RaisedButton
                style={{ marginRight: '10px' }}
                label="View"
                primary
                onClick={this.navigateToView}
              />
              <RaisedButton
                style={{ marginRight: '10px' }}
                label="Delete"
                primary
                onClick={this.handleDeleteOpen}
              />
              <RaisedButton
                label="Save"
                primary
                onClick={this.handleOpen}
              />
              <RaisedButton
                label="Sync with Netsuite"
                primary
                onClick={this.syncNetsuite}
                style={{ marginLeft: '30px' }}
              />
            </div>
            :
            <div className="float-right">
              <RaisedButton
                style={{ marginRight: '20px' }}
                label="Cancel"
                primary
                onClick={this.handleCancel}
              />
              <RaisedButton
                label="Edit"
                primary
                onClick={this.navigateToEdit}
              />
            </div>
          }
          <br />
          <TextField
            value={item.preview.numPhotos}
            onChange={this.handleNumPhotos}
            type="number"
            floatingLabelText="Number of Photos"
            name="numPhotos"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
          />
          <ItemInfo
            styles={styles}
            item={item}
            handleChange={this.handleChange}
            handleProductChange={this.handleProductChange}
            products={this.props.products}
            handleUploadedImage={this.handleUploadedImage}
            required={this.state.required}
            dropzoneStyles={dropzoneStyles}
            disableFields={this.props.navigationType}
            client={client}
          />
          <br />
          <TextField
            value={item.printWidth}
            onChange={this.handleChange}
            type="number"
            floatingLabelText="Print Width"
            name="printWidth"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
          />
          <TextField
            value={item.printHeight}
            onChange={this.handleChange}
            type="number"
            floatingLabelText="Print Height"
            name="printHeight"
            floatingLabelStyle={styles.floatingLabelStyle}
            floatingLabelFixed={true}
          />
          <br />
          <br />
          <div style={{display: 'flex'}}>
            <div style={{flex: 2}}>
                <TextField
                floatingLabelText="Mask"
                floatingLabelStyle={styles.floatingLabelStyle}
                floatingLabelFixed={true}
                value={item.maskVertical || ''}
                name="item.maskVertical"
                onChange={!this.props.navigationType ? this.handleChange : ''}
                style={styles.inputStyleLarge}
              />
              <Dropzone
                ref="dropzone"
                accept="image/jpeg, image/png, image/gif"
                style={dropzoneStyles}
                onDrop={(file) => this.onDrop(file, 'focus-product-images', "maskVertical", this.handleChange)}
              >Upload Mask</Dropzone>
              <RaisedButton
                style={{ marginLeft: '20px' }}
                label="Delete"
                primary
                onClick={(e)=>{ e.preventDefault(); this.handleDeleteImage('maskVertical', '')}}
              />
              {/* <button
                className="filestack-button"
                onClick={(e) => {
                  e.preventDefault()
                  return client.picker({
                    uploadInBackground: false,
                    onUploadDone: ((res) => {
                      console.log('RES maskVertical', res);
                      const targetName = 'maskVertical'
                      const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                      this.handleUploadedImage(targetName, targetValue)
                    })
                  }).open()
                }}
                style={dropzoneStyles}>
                <p className="filestack-uplaod">Upload Mask</p>
              </button> */}
              <br />
              <TextField
                floatingLabelText="Overlay"
                floatingLabelStyle={styles.floatingLabelStyle}
                floatingLabelFixed={true}
                value={item.maskHorizontal || ''}
                name="item.maskHorizontal"
                onChange={!this.props.navigationType ? this.handleChange : ''}
                style={styles.inputStyleLarge}
              />
              <Dropzone
                ref="dropzone"
                accept="image/jpeg, image/png, image/gif"
                style={dropzoneStyles}
                onDrop={(file) => this.onDrop(file, 'focus-product-images', "maskHorizontal", this.handleChange)}
              >Upload Overlay</Dropzone>
              <RaisedButton
                style={{ marginLeft: '20px' }}
                label="Delete"
                primary
                onClick={(e)=>{ e.preventDefault(); this.handleDeleteImage('maskHorizontal', '')}}
              />
              {/* <button
                className="filestack-button"
                onClick={(e) => {
                  e.preventDefault;
                  return client.picker({
                    uploadInBackground: false,
                    onUploadDone: ((res) => {
                      console.log('RES maskHorizontal', res);
                      const targetName = 'maskHorizontal'
                      const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                      this.handleUploadedImage(targetName, targetValue)
                    })
                  }).open()
                }}
                style={dropzoneStyles}>
                <p className="filestack-uplaod">Upload Overlay</p>
              </button> */}
              <br />
              <TextField
                floatingLabelText="Social Image"
                floatingLabelStyle={styles.floatingLabelStyle}
                floatingLabelFixed={true}
                value={item.socialImage || ''}
                name="item.socialImage"
                onChange={!this.props.navigationType ? this.handleChange : ''}
                style={styles.inputStyleLarge}
              />
              <button
                className="filestack-button"
                onClick={(e) => {
                  e.preventDefault;
                  return client.picker({
                    uploadInBackground: false,
                    onUploadDone: ((res) => {
                      console.log('RES socialImage', res);
                      const targetName = 'socialImage'
                      const targetValue = res.filesUploaded[0].url ? res.filesUploaded[0].url : ''
                      this.handleUploadedImage(targetName, targetValue)
                    })
                  }).open()
                }}
                style={dropzoneStyles}>
                <p className="filestack-uplaod">Upload Social</p>
              </button>
              <RaisedButton
                style={{ marginLeft: '20px' }}
                label="Delete"
                primary
                onClick={(e)=>{ e.preventDefault(); this.handleDeleteImage('socialImage', '')}}
              />
            </div>
            { maskHorizontal &&
            <div style={{ position: 'relative' }}>
              <img style={{ width: '300px', backgroundColor: '#ddd', border: '2px solid #ddd'}} src={ maskHorizontal || ''}/>
              {printData.portrait.map(p => {
                return <div
                  style={{
                    position: 'absolute',
                    top: `${(p.y / item.printHeight) * 100}%`,
                    left:`${(p.x / item.printWidth) * 100}%` ,
                    width: `${(p.width / item.printWidth) * 100}%`,
                    height: `${(p.height / item.printHeight) * 100}%`,
                    verticalAlign: 'middle',
                    zIndex: 5,
                    border: '1px solid #0062cc',
                    backgroundColor: 'rgba(0, 98, 204, .28)'
                  }}
                >
                </div>
              })}
            </div>}
          </div>
          <TextField
                floatingLabelText="Preview Shape"
                floatingLabelStyle={styles.floatingLabelStyle}
                floatingLabelFixed={true}
                value={item.previewShape || ''}
                name="item.previewShape"
                onChange={!this.props.navigationType ? this.handleChange : ''}
                style={styles.inputStyleLarge}
              />
              <Dropzone
                ref="dropzone"
                accept="image/jpeg, image/png, image/gif"
                style={dropzoneStyles}
                onDrop={(file) => this.onDrop(file, 'focus-product-images', "previewShape", this.handleChange)}
              >Upload Preview Shape</Dropzone>
              <RaisedButton
                style={{ marginLeft: '20px' }}
                label="Delete"
                primary
                onClick={(e)=>{ e.preventDefault(); this.handleDeleteImage('previewShape', '')}}
              />
          <br />
          <br />
        </div>
        <ShippingData
          styles={styles}
          item={this.state.item}
          disableFields={this.props.navigationType}
          handleChangeShipping={this.handleChangeShipping}
        />
        <PrintData
          styles={styles}
          item={this.state.item}
          handleChangePrintdata={this.handleChangePrintdata}
          printData={this.state.item.printData}
          disableFields={this.props.navigationType}
          numPhotos={this.state.item.preview.numPhotos}
        />
        <PreviewData
          styles={styles}
          item={this.props.item}
          handleChange={this.handleChangePreview}
          ChangePreviewImages={this.ChangePreviewImages}
          dropzoneStyles={dropzoneStyles}
          onDrop={this.onDrop}
          disableFields={this.props.navigationType}
          client={client}
          items={this.props.items}
          handleItemOptionSelect={this.handleItemOptionSelect}
          itemPreview={itemPreview}
        />
        <EditorData
          item={this.state.item}
          styles={styles}
          handleChange={this.handleChange}
          handleOrientationChange={this.handleOrientationChange}
          disableFields={this.props.navigationType}
        />
      </div>
    );
  }
}

EditItem.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditItem.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    item: state.items.item,
    items: state.items,
    products: state.products.results,
    navigationType: state.admins.navigationType,
  };
}

export default connect(mapStateToProps)(EditItem);



// WEBPACK FOOTER //
// ./src/components/items/EditItem.js